export default __webpack_public_path__ + "static/media/50.08e96b71.svg";